<template>
    <div class="w-full g bg-teal-500" style="display:grid; grid-auto-flow: dense"
         v-touch:end="endDaDown"
         v-touch:moving="ova"
         :style="{'grid-template-columns': '2fr repeat('+cols.length+', 1fr)', 'grid-template-rows':'2fr repeat('+rows.length+', 1fr)'}">

        <div>&nbsp;</div>
        <div v-for="column in nonogram.columns" class="flex flex-col justify-end no-highlight">
            <div class="text-xl relative" v-for="digit in column.digits" :class="{'is-satisfied': digit.is_satisfied}">
                {{digit.value}}
            </div>
        </div>
        <div v-for="row in nonogram.rows" class="flex justify-end pr-2 items-center no-highlight"
             style="grid-column:1/2">
            <div class="text-xl relative ml-4" v-for="digit in row.digits"
                 :class="{'is-satisfied': digit.is_satisfied}">
                {{digit.value}}
            </div>
        </div>

        <div v-for="(cell, index) in nonogram.cells" class="cursor-pointer gi"
             v-touch:start="startDaDown(cell)"
             :data-index="index"
             :class="['bg-white', 'bg-green-200','bg-red-200'][cell.value]"/>
    </div>
</template>

<script>
    import Nonogram from '../classes/Nonogram';

    export default {
        name: 'Nonogram',
        props: ['rows', 'cols'],
        data() {
            return {
                nonogram: new Nonogram(this.rows, this.cols),
                swiper: null
            };
        },
        methods: {
            startDaDown(cell) {
                return (evt) => {
                    evt.preventDefault();
                    this.nonogram.incrementCellValue(cell);

                    this.swiper = {
                        value: cell.value,
                        items: []
                    };
                    return false;
                }
            },
            endDaDown(evt) {
                this.swiper = null;
            },
            ova(evt) {
                if (this.swiper === null) {
                    return false;
                }

                if (evt.changedTouches) {
                    var my_loc = evt.changedTouches[0];
                    var index = (document.elementFromPoint(my_loc.clientX, my_loc.clientY).dataset.index);
                } else {
                    var index = evt.target.dataset.index;
                }

                if (index === undefined || this.swiper.items[index]) {
                    return false;
                }

                this.nonogram.setCellValue(index, this.swiper.value);

                this.swiper.items[index] = true;
            }
        }
    }
</script>

<style>
    .no-highlight {
        -webkit-user-select: none;
        -webkit-user-drag: none;
        -webkit-app-region: no-drag;
        cursor: default;
    }

    .g {
        background: blue;
        grid-gap: 2px;
        padding: 2px;

    }

    .g > * {
        background: white;
    }

    .gi {
        padding-top: 100%;
        touch-action: none;
    }

    .is-satisfied {
        color: #999;
    }

    .is-satisfied:after {
        content: '/';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        /*width: 100%;*/
        /*text-align: center;*/
    }

</style>
